(function () {
  function initHomeProduct(section) {
    if (!section || section.dataset.homeProductInitialized === 'true') {
      return;
    }

    section.dataset.homeProductInitialized = 'true';

    const panels = Array.from(
      section.querySelectorAll('[data-product-panel]')
    );

    if (!panels.length) {
      return;
    }

    function pausePanelMedia(panel) {
      if (!panel) {
        return;
      }

      panel.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });

      panel.querySelectorAll('iframe').forEach(function (iframe) {
        const src = iframe.getAttribute('src');

        if (src) {
          iframe.setAttribute('src', src);
        }
      });
    }

    function activateProduct(index) {
      panels.forEach(function (panel) {
        const isActive = panel.dataset.productPanel === index;

        if (!isActive) {
          pausePanelMedia(panel);
        }

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      section
        .querySelectorAll('[data-material-button]')
        .forEach(function (button) {
          const isActive = button.dataset.materialButton === index;

          button.classList.toggle('is-active', isActive);
          button.setAttribute(
            'aria-pressed',
            isActive ? 'true' : 'false'
          );
        });
    }

    // Quantity minus button state
    function updateQuantityMinusButton(quantity) {
      const input = quantity.querySelector('.quantity__input');
      const minusButton = quantity.querySelector(
        '.quantity__button[name="minus"]'
      );

      if (!input || !minusButton) {
        return;
      }

      const value = parseInt(input.value, 10) || 1;
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      const isMin = value <= min;

      minusButton.classList.toggle('is-disabled', isMin);
      minusButton.disabled = isMin;
    }

    section.querySelectorAll('.quantity').forEach(function (quantity) {
      updateQuantityMinusButton(quantity);
    });

    section.addEventListener('change', function (event) {
      if (!event.target.matches('.quantity__input')) {
        return;
      }

      const quantity = event.target.closest('.quantity');

      if (quantity) {
        updateQuantityMinusButton(quantity);
      }
    });

    section.addEventListener('click', function (event) {
      const quantityButton = event.target.closest('.quantity__button');

      if (quantityButton && section.contains(quantityButton)) {
        const quantity = quantityButton.closest('.quantity');

        if (quantity) {
          requestAnimationFrame(function () {
            updateQuantityMinusButton(quantity);
          });
        }
      }

      const materialButton = event.target.closest(
        '[data-material-button]'
      );

      if (materialButton && section.contains(materialButton)) {
        activateProduct(materialButton.dataset.materialButton);
        return;
      }

      const panel = event.target.closest('[data-product-panel]');

      if (!panel || !section.contains(panel)) {
        return;
      }

      const gallery = panel.querySelector('[data-product-gallery]');

      if (!gallery) {
        return;
      }

      const slides = Array.from(
        gallery.querySelectorAll('[data-gallery-slide]')
      );

      const thumbs = Array.from(
        gallery.querySelectorAll('[data-gallery-thumb]')
      );

      if (!slides.length) {
        return;
      }

      function getCurrentIndex() {
        const current = slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        });

        return current === -1 ? 0 : current;
      }

      function showSlide(index) {
        if (index < 0) {
          index = slides.length - 1;
        }

        if (index >= slides.length) {
          index = 0;
        }

        slides.forEach(function (slide, slideIndex) {
          const isActive = slideIndex === index;

          if (!isActive) {
            slide.querySelectorAll('video').forEach(function (video) {
              video.pause();
            });
          }

          slide.classList.toggle('is-active', isActive);
          slide.hidden = !isActive;
        });

        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle(
            'is-active',
            thumbIndex === index
          );
        });

        if (thumbs[index]) {
          thumbs[index].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }

      const thumb = event.target.closest('[data-gallery-thumb]');

      if (thumb && gallery.contains(thumb)) {
        showSlide(
          parseInt(thumb.dataset.galleryThumb, 10)
        );
        return;
      }

      if (event.target.closest('[data-gallery-prev]')) {
        showSlide(getCurrentIndex() - 1);
        return;
      }

      if (event.target.closest('[data-gallery-next]')) {
        showSlide(getCurrentIndex() + 1);
      }
    });
  }

  function initAllHomeProducts(root) {
    const context = root || document;

    if (
      context.matches &&
      context.matches('[data-home-product]')
    ) {
      initHomeProduct(context);
    }

    context
      .querySelectorAll('[data-home-product]')
      .forEach(initHomeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHomeProducts(document);
    });
  } else {
    initAllHomeProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHomeProducts(event.target);
  });
})();